export default __webpack_public_path__ + "assets/images/85c4c33f6955978f1977923bc1627acb.png";